export enum PerformanceQASelectors {
    EVENT_CARD_INFO = 'event-card-info',
    TICKET_SELECTION = 'ticket-selection',
    STEPPER_AMOUNT = 'stepper-amount',
    PRICE_LEVEL = 'price-level',
    PRICE_LEVEL_ALTERNATIVE = 'price-level-alternative',
    PRICE_LEVEL_CIRCLE_INDICATOR = 'price-level-circle-indicator',
    PRICE_LEVEL_SUBMIT = 'price-level-submit',
    SEATMAP_WRAPPER = 'seatmap-wrapper',
    SEATMAP_BUTTONS = 'seatmap-buttons',
    SUBMIT_BUTTON = 'submit-button',
    PRICE_LEVEL_TICKET = 'price-level-ticket',
    PRICE_LEVEL_TITLE = 'price-level-title',
    TICKET_INFORMATION = 'ticket-information',
    TICKET_TYPE = 'ticket-type',
    PROMOTION_CODE = 'promotion-code',
    PROMO_ARROW = 'promo-arrow',
    APPLIED_PROMO_CODE = 'applied-promo-code',
    BEST_SEAT_SELECTION = 'best-seat-selection',
}